import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    setDocumenti,
    addDocumenti,
    addDocumentiId,
    updateDocumenti,
    deleteDocumenti,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    enumRequestFailure,
    enumRequestStart,
    enumRequestSuccess,
    setTipologiaDocumento,
    setdeleteDocumenti,
  } from "./documentiSlice.js";
  import documentiAPI from "../../services/documentiAPI.js";

  
  export const fetchDocumenti = createAsyncThunk(
    "documentiData/fetchDocumenti",
    async (_, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await documentiAPI.getAllDocumenti();
        dispatch(setDocumenti(response.data.data));
        console.log(response.data.data, 'data of fetch');
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch prodotti.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
  export const singleDocumenti = createAsyncThunk(
    "mezzi/fetchSingleMezzi",
    async (documentiId, {dispatch}) => {
      dispatch(apiRequestStart());
      try {
        const response = await documentiAPI.getSingleDocumenti(documentiId);
        // Make sure we're storing the data properly in state
        dispatch(addDocumentiId([response.data.data]));
        // Add logging to debug
        // console.log("Single Prodotto data:", response.data.data);
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch single prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  )
  export const createdocumenti = createAsyncThunk(
    "mezziData/createMezzi",
    async (payload, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await documentiAPI.createDocumenti(payload);
        dispatch(addDocumenti(response.data.data));
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to create prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
  export const updateDocumentiData = createAsyncThunk(
    "mezziData/updateMezzi",
    async ({ id, data }, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        const response = await documentiAPI.updateDocumenti(id, data);
        dispatch(updateDocumenti(response.data.data));
        dispatch(apiRequestSuccess());
        return response.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to update prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );
  export const deleteDocumentiData = createAsyncThunk(
    "mezziData/deleteMezzi",
    async (id, { dispatch }) => {
      dispatch(apiRequestStart());
      try {
        await documentiAPI.deleteDocumenti(id);
        dispatch(setdeleteDocumenti(id));
        dispatch(apiRequestSuccess());
        return id;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to delete prodotto.";
        dispatch(apiRequestFailure(errorMessage));
        throw new Error(errorMessage);
      }
    }
  );

  export const fetchtipologiaDocumento = createAsyncThunk(
    "mezziData/fetchMezzo",
    async (_, { dispatch }) => {
      dispatch(enumRequestStart("mezzo"));
      try {
        const response = await documentiAPI.gettipologiaDocumento();
        // console.log("Tipologia API Response:", response.data.data);
        dispatch(setTipologiaDocumento(response.data.data)); // Use setTipologia action instead of selectTipologia
        dispatch(enumRequestSuccess("mezzo"));
        return response.data.data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Failed to fetch tipologia.";
        dispatch(
          enumRequestFailure({
            enumType: "TipologiaDocumento",
            error: errorMessage,
          })
        );
        throw new Error(errorMessage);
      }
    }
  );





